// Central brand data for Prowave Amplifiers

export const BRAND = {
  logo: "/images/logo.png",
  company: "Wave Audio Co.",
  product: "Prowave Amplifiers",
  phone: "+91 9810573206",
  phoneRaw: "+919810573206",
  whatsapp: "919810573206",
  email: "sales@waveaudioco.in",
  address: "E-65, Sector 7, Noida, Uttar Pradesh 201301, India",
  mapDirections:
    "https://www.google.com/maps/dir/?api=1&destination=28.5957513,77.3143236",
  mapEmbed:
    "https://www.google.com/maps?q=28.5957513,77.3143236&output=embed",
};

// Official downloadable catalogue (uploaded PDF)
export const CATALOGUE_URL =
  "/images/catalogue.pdf";

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Why Prowave", href: "#why" },
  { label: "Catalogue", href: "#catalogue" },
  { label: "Contact", href: "#contact" },
];

export const HERO_IMAGE =
  "/images/bw-10000.webp";

// Product CATEGORIES (7 total).
export const PRODUCTS = [
  {
    id: "insulation",
    category: "Installation Amplifiers",
    model: "USB 600",
    tag: "Featured Model",
    image:
      "/images/usb-600.webp",
  },
  {
    id: "low-power",
    category: "Low Power Amplifiers",
    model: "USB 1600",
    tag: "Featured Model",
    image:
      "/images/usb-1600.webp",
  },
  {
    id: "mid-power",
    category: "Mid Power Amplifiers",
    model: "USB 3000",
    tag: "Featured Model",
    image:
      "/images/usb-3000.webp",
  },
  {
    id: "high-power",
    category: "High Power Amplifiers",
    model: "USB 10000 A",
    tag: "Featured Model",
    image:
      "/images/usb-10000-a.webp",
  },
  {
    id: "dual-channel",
    category: "Dual Channel Amplifiers",
    model: "USB 5000 DZ",
    tag: "Featured Model",
    image:
      "/images/usb-5000-dz.webp",
  },
  {
    id: "dual-booster",
    category: "Dual Channel Boosters",
    model: "TZ 500+500",
    tag: "Featured Model",
    image:
      "/images/tz-500-500.webp",
  },
  {
    id: "dj-series",
    category: "DJ Series",
    model: "TZ 32000",
    tag: "Featured Model",
    image:
      "/images/tz-32000.webp",
  },
];

export const FEATURES = [
  {
    n: "01",
    title: "Reliable Build Quality",
    body: "Every unit is built with durable components and rigorous quality checks, designed to perform under continuous, demanding use.",
    icon: "ShieldCheck",
  },
  {
    n: "02",
    title: "Pan-India Network",
    body: "A strong dealer and distribution network across India ensures Prowave products reach you quickly, wherever you're based.",
    icon: "MapPinned",
  },
  {
    n: "03",
    title: "Export Ready",
    body: "Manufactured to meet international standards, Prowave amplifiers are trusted by clients beyond Indian borders.",
    icon: "Globe2",
  },
  {
    n: "04",
    title: "After-Sales Support",
    body: "Our team stands behind every product with responsive support and service, so your investment keeps performing.",
    icon: "Headphones",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Engineered in India",
    body: "Wave Audio Co. designs and manufactures Prowave amplifiers for professional and commercial audio applications.",
  },
  {
    n: "02",
    title: "Built to Endure",
    body: "Amplifiers engineered for reliability, power efficiency, and long-term performance under the most demanding loads.",
  },
  {
    n: "03",
    title: "Trusted Nationwide",
    body: "A distribution network spanning across India and a growing export presence.",
  },
];
